<template>
    <div class="section">
        <title-bar title="筛选分区" :back-cb="close"></title-bar>
        <div class="section_content">
            <div class="all">
                <div class="group_text">全部</div>
                <div class="option" :class="{'on':selectedId=='all'}" @click="selectSection({id:'all'})">全部分组</div>
            </div> 
            <div class="select">
                <div class="group_text">筛选分区</div>
                <div 
                    class="option border-bottom" 
                    :class="{'on':selectedId==item.id}" 
                    v-for="(item,index) in sections" 
                    :key="index"
                    @click="selectSection(item)"
                >
                    {{item.name}}
                </div>
            </div>
            <div class="no_option" v-if="!sections.length">
                当前项目没有创建分区 <br/>可登录 Web 端创建
            </div>
        </div>
    </div>
</template>

<script>
import titleBar from "@/components/layout/TitleBar"
export default {
    props: {
        projectId: "",
        selectedId: {
            default() {
                return "all"
            }
        }
    },
    data() {
        return {
            sections: []
        }
    },
    mounted() {
        this.iniSelect()
    },
    methods: {
        iniSelect() {
            this.selected = this.$route.query.id ? this.$route.query.id : "all"
            this.getSections()
        },
        selectSection(item) {
            this.$emit("select", item)
            this.close();

            MtaH5.clickStat("switch_group")
        },
        async getSections() {
            let res = await API.project.getSectors(this.projectId)
            if (res) {
                let data = res.data.data
                this.sections = data.sectors
            }
        },
        close() {
            this.$emit("close")
        }
    },
    components: {
        titleBar
    }
}
</script>

<style lang="scss" scoped>
.section {
    height: 100%;
    width: 100%;
    // padding-top: 2.35rem; //android_top
    padding-top: 2.35rem; //ios_top
    // padding-top:calc(constant(safe-area-inset-top) + 1.35rem) ;
    // padding-top:calc(env(safe-area-inset-top) + 1.35rem) ;
    box-sizing: border-box;

    .section_content {
        height: 100%;
        overflow-y: auto;
        background: white;
        .group_text {
            padding: 0.25rem 0.5rem;
            height: 0.65rem;
            font-size: 0.65rem;
            font-weight: 400;
            color: rgba(136, 136, 136, 1);
            line-height: 0.65rem;
            background: #edeff1;
        }
        .option {
            padding: 0 0.6rem;
            height: 2rem;
            font-size: 0.75rem;
            color: rgba(0, 0, 0, 1);
            line-height: 2rem;
            background: white;
            &.on {
                background: url("~@/assets/imgs/selected.png") 95% center / 0.75rem no-repeat;
            }
        }
        .no_option {
            width: 100%;
            text-align: center;
            font-size: 0.7rem;
            color: rgba(136, 136, 136, 1);
            line-height: 1rem;
            position: absolute;
            top: 50%;
            left: 0;
            transform: translate(0, -50%);
        }
    }
}
</style>
